import type { InputHTMLAttributes } from 'react';
import { cn } from '../lib/utils.js';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/** Design-system text input. Pair with `Field` for label + hint + error. */
export function Input({ className, type = 'text', ...rest }: InputProps) {
  return (
    <input
      type={type}
      className={cn(
        'flex h-12 w-full rounded-xl border border-border bg-surface px-4 text-base text-fg',
        'placeholder:text-fg-muted/70',
        'transition-[border-color,box-shadow] duration-150',
        'focus-visible:outline-none focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-[invalid=true]:border-red-500 aria-[invalid=true]:ring-red-500/30',
        className,
      )}
      {...rest}
    />
  );
}
